var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastring = function SvgMastring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M8.66661 16C10.1394 16 11.3333 14.8061 11.3333 13.3333C11.3333 11.8606 10.1394 10.6667 8.66661 10.6667M8.66661 16C7.19385 16 5.99994 14.8061 5.99994 13.3333C5.99994 11.8606 7.19385 10.6667 8.66661 10.6667M8.66661 16V24M8.66661 10.6667V2.66666M16.6666 21.3333C18.1394 21.3333 19.3333 20.1394 19.3333 18.6667C19.3333 17.1939 18.1394 16 16.6666 16M16.6666 21.3333C15.1938 21.3333 13.9999 20.1394 13.9999 18.6667C13.9999 17.1939 15.1938 16 16.6666 16M16.6666 21.3333V24M16.6666 16V2.66666M24.6666 12C26.1394 12 27.3333 10.8061 27.3333 9.33333C27.3333 7.86057 26.1394 6.66666 24.6666 6.66666M24.6666 12C23.1938 12 21.9999 10.8061 21.9999 9.33333C21.9999 7.86057 23.1938 6.66666 24.6666 6.66666M24.6666 12V24M24.6666 6.66666V2.66666",
    stroke: "var(--accent)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M4.66663 29.3333H7.33329M0.666626 29.3333H1.99996M9.99996 29.3333H15.3333M18 29.3333H32.6666",
    stroke: "var(--accent)",
    strokeWidth: 2
  })));
};
export default SvgMastring;